import { usePeriod } from '@/app/context/PeriodContext';
import { Project } from '@/app/models/project';
import { useProjectsQuery } from '@/app/services/projectApi';
import { useFindAllGroupedByDebitProjectQuery } from '@/app/services/SharingDetails';
import SharingTable from '@/components/sharingDetails/SharingTable';
import searchIcon from '@/icons/search.svg';
import { Autocomplete, Box, InputAdornment, InputProps, TextField, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function SharingMocked() {
  const theme = useTheme();
  const period = usePeriod();
  const { t } = useTranslation(['sharingDetails']);

  const [costCenter, setCostCenter] = useState('');
  const [searchCostCenter, setSearchCostCenter] = useState('');
  const [selectedCostCenter, setSelectedCostCenter] = useState<Project | null>(null);

  const { data: costCenters } = useProjectsQuery(
    {
      bringClose: false,
      searchTerm: searchCostCenter,
      page: 0,
      size: 10,
    },
    {
      skip: !searchCostCenter || !searchCostCenter,
    },
  );

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const { data: sharingDetailsDebitProject } = useFindAllGroupedByDebitProjectQuery(
    {
      data: period.selectedPeriod?.date as string,
      searchTerm: selectedCostCenter?.code || '',
      page,
      size,
    },
    {
      skip: !period.selectedPeriod?.date,
    },
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box sx={{ width: theme.spacing(50), mb: 2 }}>
        <Typography variant="h3" sx={{ marginTop: 3 }}>
          {t('project')}
        </Typography>
        <Autocomplete
          freeSolo
          filterOptions={(option) => option}
          isOptionEqualToValue={(option, value) => option?.code === value?.code}
          style={{ width: '100%', marginRight: '10px', marginTop: '8px' }}
          size="small"
          defaultValue={selectedCostCenter}
          onChange={(event, newValue) => {
            setSelectedCostCenter(newValue as Project);
          }}
          inputValue={costCenter}
          onInputChange={(event, newInputValue) => {
            setCostCenter(newInputValue);
            if (newInputValue.length >= 1) {
              setSearchCostCenter(newInputValue);
            }
          }}
          options={costCenters?.content || []}
          getOptionLabel={(option) => (typeof option === 'string' ? option : `${option.code} - ${option.name} `)}
          renderOption={(params, option) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <Box component="li" sx={{ fontSize: '13px', '& > img': { mr: 2, flexShrink: 0 } }} {...params}>
              {`${option.code} - ${option.name} `}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              sx={{
                '& input': {
                  padding: '0px',
                },
              }}
              size="small"
              style={{ width: 'inherit', height: '32px', fontSize: '13px' }}
              ref={params.InputProps.ref}
              InputProps={
                {
                  ...params.inputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <img src={searchIcon} alt={t('search.icon') as string} />
                    </InputAdornment>
                  ),
                  style: {
                    paddingRight: '10px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    paddingLeft: '10px',
                    fontSize: '13px',
                  },
                } as InputProps
              }
              autoFocus
              placeholder={t('common:enter.result.center.name.or.code') as string}
            />
          )}
        />
      </Box>

      <SharingTable rows={sharingDetailsDebitProject?.content || []} />
    </Box>
  );
}

export default SharingMocked;
